export default "__VITE_ASSET__kCSKSlxY__"